import React from 'react';
import { Button } from '@trussworks/react-uswds';
import classNames from 'classnames';
import './linkButton.scss';
import { useNavigate } from '@tanstack/react-router';

const LinkButton = ({ href, onClick, children, content, className, ...customProps }) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    // If an onClick prop was provided, call it and prevent default navigation
    if (onClick) {
      event.preventDefault(); // Prevent the default action to ensure custom logic can run
      onClick(event);
    } else {
      // Fallback to default navigation
      href && navigate({ to: href });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === 'Spacebar' || event.key === ' ') {
      event.preventDefault(); // Prevent scrolling when 'Space' is pressed
      handleClick(event);
    }
  };

  const buttonStyles = classNames(className, {
    'link-button-style': !className,
  });

  return (
    <Button
      aria-label={`Navigate to ${content ?? children}`}
      className={buttonStyles}
      onClick={handleClick}
      onKeyUp={handleKeyPress}
      role='link'
      tabIndex={0}
      title={children}
      {...customProps}
    >
      {content || children}
    </Button>
  );
};

export default LinkButton;
